import { InputDateControllerVertical } from "./InputDateControllerVertical";
import { SelectControllerVertical } from "./SelectControllerVertical";

import { useLanguage } from "@hooks/useLanguage";
import { useBaseData } from "@hooks/useBaseData";

import { BASE_DATA } from "@constants/base-data";

import {
  getConvertedPositionData,
  getConvertedUnitData,
  getConvertedOfficeAddress,
} from "@helpers/baseDataConvert";

const { DESIGNATIONS, WINGS, OFFICE } = BASE_DATA;

type HrmEmployeeFilterPropType = {
  handleQuery: (key: string, value: any) => void;
  control: any;
  register: any;
  setValue: any;
  withoutDates?: boolean;
};

export const HrmEmployeeFilter = ({
  handleQuery,
  control,
  register,
  setValue,
  withoutDates,
}: HrmEmployeeFilterPropType) => {
  const { language } = useLanguage();

  const { data: positions } = useBaseData(DESIGNATIONS);
  const { data: wings } = useBaseData(WINGS);
  const { data: office } = useBaseData(OFFICE);

  return (
    <div className="bg-light rounded p-10">
      <div className="row pb-0 mb-0">
        {!withoutDates && (
          <>
            <InputDateControllerVertical
              control={control}
              label="HRM_EMPLOYEE_FILTER.FILTER.START_DATE"
              name="startDate"
              register={{
                ...register("startDate"),
              }}
              onSelectDate={(date) => {
                if (date) {
                  handleQuery("startDate", date);
                } else {
                  handleQuery("startDate", null);
                }
              }}
              portal
              cols={3}
            />
            <InputDateControllerVertical
              control={control}
              label="HRM_EMPLOYEE_FILTER.FILTER.END_DATE"
              name={"endDate"}
              register={{
                ...register("endDate"),
              }}
              onSelectDate={(date) => {
                if (date) {
                  handleQuery("endDate", date);
                } else {
                  handleQuery("endDate", null);
                }
              }}
              portal
              cols={3}
            />
          </>
        )}
        <SelectControllerVertical
          control={control}
          label="HRM_EMPLOYEE_FILTER.FILTER.OFFICE"
          name="officeId"
          options={getConvertedOfficeAddress(office, language)}
          register={register}
          setValue={setValue}
          isSearchable
          selectAction={(e) => {
            handleQuery("officeId", e);
          }}
          portal
          cols={3}
        />

        <SelectControllerVertical
          control={control}
          label="HRM_EMPLOYEE_FILTER.FILTER.DESIGNATION"
          name="positionId"
          options={getConvertedPositionData(positions, language)}
          register={register}
          setValue={setValue}
          isSearchable
          selectAction={(e) => {
            handleQuery("positionId", e);
          }}
          portal
          cols={3}
        />

        <SelectControllerVertical
          control={control}
          label="HRM_EMPLOYEE_FILTER.FILTER.UNIT"
          name="unitId"
          options={getConvertedUnitData(
            wings.filter((item: any) => item?.name !== "ACC"),
            language,
          )}
          register={register}
          setValue={setValue}
          isSearchable
          selectAction={(e) => {
            handleQuery("unitId", e);
          }}
          portal
          cols={3}
        />
      </div>
    </div>
  );
};
